import { useMemo, useCallback } from 'react';
import { isOwnDomainEmail } from 'api';
import { useAppSelector } from '@web-common/state/createStore';
const FORWARD_WHITELIST_DOMAINS = ['lx901.com', 'xdf.cn'];
function matchWhitelist(domainList) {
    if (!domainList || domainList.length === 0) {
        return false;
    }
    return domainList.some(d => {
        const dn = d.domain;
        if (!dn)
            return false;
        return FORWARD_WHITELIST_DOMAINS.some(w => dn === w || dn.endsWith(`.${w}`));
    });
}
export function useForwardEmailPolicy() {
    const orgInfo = useAppSelector(state => state.loginReducer.orgInfo);
    const domainList = orgInfo === null || orgInfo === void 0 ? void 0 : orgInfo.domain_list;
    const ready = Array.isArray(domainList) && domainList.length > 0;
    const isWhitelisted = useMemo(() => matchWhitelist(domainList), [domainList]);
    const maxCount = isWhitelisted ? 20 : 1;
    const ownDomainSet = useMemo(() => {
        if (!isWhitelisted || !domainList)
            return undefined;
        return new Set(domainList.map(d => d.domain).filter(Boolean));
    }, [isWhitelisted, domainList]);
    const isInOwnDomain = useCallback((email) => {
        if (!isWhitelisted || !ownDomainSet)
            return true;
        return isOwnDomainEmail(email, ownDomainSet);
    }, [isWhitelisted, ownDomainSet]);
    return { ready, isWhitelisted, maxCount, ownDomainSet, isInOwnDomain };
}
